const ROUTE_PATHS = {
  // --- LOGIN ----
  LOGIN: "/",
  // ---- Dashboard Route ----
  DASHBOARD: "/app",

  // ---- Product Routes ----
  PRODUCT: {
    BASE: "/app/product-catalog/product",
    CREATE: "/app/product-catalog/product/create",
    UPDATE: (id: string) => `/app/product-catalog/product/update/${id}`
  },

  // ---- Category Routes ----
  CATEGORY: {
    BASE: "/app/product-catalog/category",
    CREATE: "/app/product-catalog/category/create",
    UPDATE: (id: string) => `/app/product-catalog/category/update/${id}`
  },

  // ---- Discount Routes ----
  DISCOUNTS: {
    BASE: "/app/sales-orders/discounts",
    CREATE: "/app/sales-orders/discounts/create",
    UPDATE: (id: string) => `/app/sales-orders/discounts/update/${id}`
  },

  // ---- Manufacturer Routes ----
  MANUFACTURER: {
    BASE: "/app/procurement/manufacturer",
    CREATE: "/app/procurement/manufacturer/create",
    UPDATE: (id: string) => `/app/procurement/manufacturer/update/${id}`
  },

  // ---- BOM (Bill of Material) Routes ----
  BOM: {
    BASE: "/app/production/bom",
    CREATE: "/app/production/bom/new",
    DETAILS: (id: string) => `/app/production/bom/details/${id}`,
    VERSION_CREATE: (id: string) => `/app/production/bom/details/${id}/versions/new`,
    VERSION_DETAILS: (versionId: string) => `/app/production/bom/version/${versionId}`
  },

  // ---- Production Plan & Order ----
  PRODUCTION_PLAN: {
    BASE: "/app/production/plans",
    DETAILS: (id: string) => `/app/production/plans/details/${id}`
  },
  PRODUCTION_ORDER: {
    BASE: "/app/production/orders",
    DETAILS: (id: string) => `/app/production/orders/details/${id}`
  },

  // ---- Vendor Routes ----
  VENDOR: {
    BASE: "/app/procurement/vendor",
    CREATE: "/app/procurement/vendor/create",
    UPDATE: (id: string) => `/app/procurement/vendor/update/${id}`
  },

  // ---- Purchase Order Routes ----
  PURCHASE_ORDER: {
    BASE: "/app/procurement/purchase-order",
    CREATE: "/app/procurement/purchase-order/create",
    UPDATE: (id: string) => `/app/procurement/purchase-order/update/${id}`
  },

  // ---- GRN (Goods Received Note) Routes ----
  GRN: {
    BASE: "/app/procurement/grn",
    CREATE: "/app/procurement/grn/create",
    DETAILS: (id: string) => `/app/procurement/grn/details/${id}`
  },

  // ---- Stock Return Routes ----
  STOCK_RETURN: {
    BASE: "/app/procurement/stock-return",
    CREATE: "/app/procurement/stock-return/create"
  },

  // ---- Stock Intake Route ----
  STOCK_INTAKE: "/app/inventory-management/stock-intake",

  // ---- Stock Transfer Routes ----
  STOCK_TRANSFER: {
    BASE: "/app/inventory-management/stock-transfer",
    CREATE: "/app/inventory-management/stock-transfer/create",
    STOCK_RECEIVE: (transferId: string) => `/app/inventory-management/stock-transfer/stock-receive/${transferId}`
  },

  // ---- Stock Operation Routes ----
  STOCK_OPERATION: {
    BASE: "/app/inventory-management/stock-operation",
    CREATE: "/app/inventory-management/stock-operation/create",
    DETAILS: (id: string) => `/app/inventory-management/stock-operation/details/${id}`
  },

  // ---- Transfer Receipt Route ----
  TRANSFER_RECEIPT: "/app/inventory-management/transfer-receipt",

  // ---- Demand Note Routes ----
  DEMAND_NOTE: {
    BASE: "/app/demand-supply-planning/demand-note",
    DETAILS: "/app/demand-supply-planning/demand-note/details",
    CREATE: "/app/demand-supply-planning/demand-note/create"
  },

  // ---- Inventory Report Route ----
  INVENTORY_REPORT: "/app/report-analytics/inventory-report",

  // ---- Dashboards & Reports Routes ----
  DASHBOARDS: "/app/report-analytics/dashboards",
  DASHBOARD_VIEW: "/app/report-analytics/dashboards/:id",
  REPORTS: "/app/report-analytics/reports",
  REPORT_NEW: "/app/report-analytics/reports/new",
  REPORT_VIEW: "/app/report-analytics/reports/:id",
  REPORT_EDIT: "/app/report-analytics/reports/:id/edit",
  REPORT_PIVOT: "/app/report-analytics/reports/:id/pivot",
  TARGET_NEW: "/app/report-analytics/reports/target/new",
  TARGET_EDIT: "/app/report-analytics/reports/target/:id/edit",
  SQL_REPORT_NEW: "/app/report-analytics/reports/sql/new",
  SQL_REPORT_EDIT: "/app/report-analytics/reports/sql/:id/edit",

  // ---- Register Route ----
  REGISTER: {
    BASE: "/app/sales-orders/register",
    OPEN_REGISTER: (registerId: string) => `/app/sales-orders/register/${registerId}/open`,
    CLOSE_REGISTER: (registerId: string) => `/app/sales-orders/register/${registerId}/close`,
    SESSIONS_LIST: (sessionId: string) => `/app/sales-orders/register/sessions/${sessionId}`
  },

  // ---- Return Order Route ----
  RETURN_ORDER: "/app/sales-orders/return-order",

  // ---- Lost Sale Routes ----
  LOST_SALE: {
    BASE: "/app/sales-orders/lost-sale"
  },

  // ---- Fulfillment Routes ----
  FULFILLMENT_ORDERS: {
    BASE: "/app/fulfillment/orders",
    DETAILS: (id: string) => `/app/fulfillment/orders/details/${id}`,
    PICKER: "/app/fulfillment/picker",
    DISPATCH: "/app/fulfillment/dispatch",
    CARRIERS: "/app/fulfillment/carriers",
    CARRIER_DETAIL: (connectionId: string) => `/app/fulfillment/carriers/${connectionId}`
  },

  // ---- Order Management Routes ----
  ORDER_MANAGEMENT: {
    BASE: "/app/sales-orders/order-management",
    DETAILS: (id: string) => `/app/sales-orders/order-management/details/${id}`
  },

  // ---- Customers Route ----
  CUSTOMERS: {
    BASE: "/app/customers-partners/customers",
    CREATE_CUSTOMERS: "/app/customers-partners/customers/create",
    UPDATE_CUSTOMERS: (id: string) => `/app/customers-partners/customers/update/${id}`
  },
  // ---- Partners Route ----
  PARTNERS: "/app/customers-partners/partners",

  // ---- Users Route ----
  USERS: {
    BASE: "/app/system/users"
  },

  // ---- Locations Route ----
  LOCATIONS: { BASE: "/app/system/locations" },

  // ---- Roles Route ----
  ROLES: {
    BASE: "/app/system/roles",
    CREATE: "/app/system/roles/create",
    UPDATE: (roleId: string) => `/app/system/roles/update/${roleId}`
  },

  // ---- POS App Path -----
  POS: {
    BASE: (locationId: string, registerId: string) => `/pos/${locationId}/${registerId}`
  },

  // ------- Invoice ---------
  INVOICE: {
    PO_INVOICE: (purchaseOrderId: string) => `/invoice/po-invoice/${purchaseOrderId}`,
    GRN_INVOICE: (grnId: string) => `/invoice/grn-invoice/${grnId}`,
    STOCK_RETURN_INVOICE: (stockReturnId: string) => `/invoice/stock-return-invoice/${stockReturnId}`
  },

  // ---- Adjustments Route ----
  ADJUSTMENTS: {
    BASE: "/app/system/adjustments",
    CREATE: "/app/system/adjustments/create",
    DETAILS: (adjustmentId: string) => `/app/system/adjustments/?id=${adjustmentId}`
  },

  // ---- Audit Route ----
  AUDIT: {
    BASE: "/app/system/audit",
    EXECUTION: (auditId: string) => `/app/system/audit/execution/${auditId}`
    // DETAILS: (auditId: string) => `/app/system/audit/details/${auditId}`
  },
  // ---- Audit Route ----
  PLATFORM_FEE_CONFIG: {
    BASE: "/app/system/platform-fee-config"
  },
  // ---- Register Route ----
  REGISTER_MANAGEMENT: {
    BASE: "/app/system/register"
  },
  // ---- Integrations Route ----
  INTEGRATIONS: {
    BASE: "/app/system/integrations"
  },

  // ---- Sales Channels Route ----
  INTEGRATIONS_HUB: {
    BASE: "/app/system/connected-apps"
  },

  // ---- Accounting Routes ----
  ACCOUNTING: {
    BASE: "/app/accounting",
    HOME: "/app/accounting",
    CHART_OF_ACCOUNTS: "/app/accounting/chart-of-accounts",
    ACCOUNT_SUBTYPE: "/app/accounting/account-subtype",
    BANK_ACCOUNT: "/app/accounting/bank-account",
    ASSET_CLASS: "/app/accounting/asset-class",
    ASSET_MASTER: "/app/accounting/asset-master",
    SOURCE_MODULE: "/app/accounting/source-module",
    ACCOUNTS_RECEIVABLE: "/app/accounting/accounts-receivable",
    ACCOUNTS_PAYABLE: "/app/accounting/accounts-payable",
    CASH: "/app/accounting/cash",
    CASH_ACCOUNT: "/app/accounting/cash-account",
    CASH_DEPOSIT: "/app/accounting/cash-deposit",
    PROFIT_CENTER: "/app/accounting/profit-center",
    COST_CENTER: "/app/accounting/cost-center",
    FISCAL_YEAR: "/app/accounting/fiscal-year",
    INVOICE_POLICY: "/app/accounting/invoice-policy",
    ENTITY: "/app/accounting/entity",
    PAYMENT_TERMS: "/app/accounting/payment-terms",
    JOURNAL_ENTRY: {
      BASE: "/app/accounting/journal-entry",
      CREATE: "/app/accounting/journal-entry/create"
    },
    REPORTS: {
      BASE: "/app/accounting/reports",
      BALANCE_SHEET: "/app/accounting/reports/balance-sheet",
      INCOME_STATEMENT: "/app/accounting/reports/income-statement",
      GENERAL_LEDGER: "/app/accounting/reports/general-ledger",
      TRIAL_BALANCE: "/app/accounting/reports/trial-balance"
    }
  }
}

export default ROUTE_PATHS
